import { createContext } from 'react';

export const NetworkStatusContext = createContext<{
  isOnline: boolean;
  isNetworkSlow: boolean;
  isBackOnline: boolean;
  closeBackOnlineBanner: () => void;
} | null>(null);
